import polyglotI18nProvider from "ra-i18n-polyglot";

import { englishMessages } from "./translations/englishMessages";
import { germanMessages } from "./translations/germanMessages";

export const i18nProvider = polyglotI18nProvider(
  locale => (locale === "en" || locale.startsWith("en-") ? { ...germanMessages, ...englishMessages } : germanMessages),
  "de"
);
